//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useContext, useEffect, useState } from 'react';
import { InputAdornment, makeStyles } from '@material-ui/core';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
// import CloseIcon from '@material-ui/icons/Close';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { setClassNameInDefns } from '../../common/definitionHelper';
import { LayoutContext } from '../../common/contexts';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTextField from '../../common/elemental/AfitdTextField';
import AfitdButton from '../../common/elemental/AfitdButton';
// import AfitdIconButton from '../../common/elemental/AfitdIconButton';
import AfitdLink from '../../common/elemental/AfitdLink';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    const { noClearFilters, showClearFilters, querySearchText } = params;
    const displayClearFiltersLink = !noClearFilters && showClearFilters && querySearchText;

    return makeStyles(theme => ({
        root: { display: 'flex', flexDirection: 'column', height: displayClearFiltersLink ? 96 : 48, background: 'transparent', borderRadius: '4px', marginBottom: 10 },
        inputContainer: { flex: 1, display: 'flex', alignItems: 'center', margin: '0 -5px' },
        searchField: { margin: '0 5px' },
        // searchButtonContainer: {},
        searchButton: { margin: '0 5px', height: 56 },
        // searchIcon: { fontSize: 22, margin: '0 10px', color: 'rgba(17,30,20,0.4)' },
        // crossIcon: { fontSize: 22, margin: '0 10px', color: 'rgba(17,30,20,0.4)', cursor: 'pointer' },
        clearAllFiltersContainer: {
            display: displayClearFiltersLink ? 'flex' : 'none',
            justifyContent: 'flex-end',
            cursor: 'pointer',
        },
        clearAllFiltersLink: {
            color: '#374EF5',
            textDecoration: 'underline',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props, searchText, handleChangeSearch, handleKeyPress, handleClickSearchButton, handleClickClearFilters } = params;
    const { placeholder = 'Search' } = props;

    const searchButtonDisabled = false; //_size(searchText) < 3;

    const defns = {
        searchField: {
            placeholder,
            value: searchText,
            onChange: handleChangeSearch,
            onKeyPress: handleKeyPress,
            color: 'secondary',
            InputProps: {
                startAdornment: (
                    <InputAdornment position="start">
                        {/* <AfitdIconButton> */}
                        <SearchOutlinedIcon style={{ color: '#3C3C3C' }} />
                        {/* </AfitdIconButton> */}
                    </InputAdornment>
                ),
                // endAdornment: (
                //     <InputAdornment position="end">
                //         <CloseIcon />
                //     </InputAdornment>
                // ),
            },
            inputProps: { maxLength: 500 },
        },
        searchButton: {
            // color: 'secondary',
            disabled: searchButtonDisabled,
            onClick: handleClickSearchButton,
        },
        clearAllFiltersLink: {
            onClick: handleClickClearFilters,
        },
    };

    setClassNameInDefns(defns, classes);
    return defns;
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const SearchInput = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const layoutContext = useContext(LayoutContext);
    const { query } = layoutContext;
    const querySearchText = _get(query, 'searchText');

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { noClearFilters, onSearch, onClearFilters, showClearFilters } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [searchText, setSearchText] = useState();

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        const querySearchText = _get(query, 'searchText');
        if (!querySearchText) setSearchText('');
    }, [query]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleChangeSearch = evt => {
        const value = evt.target.value;
        setSearchText(value);
    };

    const handleClickSearchButton = () => {
        if (onSearch) {
            onSearch(searchText);
        }
    };

    const handleKeyPress = evt => {
        if (evt.key === 'Enter') {
            evt.preventDefault();
            // if (_size(searchText) >= 3) {
            //     handleClickSearchButton();
            // }
            handleClickSearchButton();
        }
    };

    const handleClickClearFilters = evt => {
        setSearchText('');
        onClearFilters && onClearFilters();
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const classes = useStyles({ noClearFilters, showClearFilters, querySearchText })();
    const defns = getDefns({ classes, props, searchText, handleChangeSearch, handleKeyPress, handleClickSearchButton, handleClickClearFilters });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.inputContainer}>
                <AfitdTextField {...defns.searchField} />
                <AfitdButton {...defns.searchButton}>Search</AfitdButton>
            </div>
            <div {...defns.clearAllFiltersContainer}>
                <AfitdLink {...defns.clearAllFiltersLink}>Clear filter</AfitdLink>
            </div>
        </div>
    );
};

export default SearchInput;
